var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',_vm._g({staticStyle:{"display":"flex"},on:{"click":function($event){return _vm.doClick(_vm.button)}}},_vm.handlers),[_c('div',{class:'box '+_vm.buttonColor}),_c('div',[_vm._v(_vm._s(_vm.button.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }